var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Card, compose, graphql, Grid, GridColumn, RightDiv, Separator, Spinner, Table, Link } from "@atlassiansox/microscopekit";
import ShortcutIcon from "@atlaskit/icon/glyph/shortcut";
import { statusLozenge } from "../../utils/Utils";
import WargameDashboardQuery from "../../graphql/wargame-dashboard.query.graphql";
import WargameDetailsQuery from "../../graphql/wargame-details.query.graphql";
import Button, { ButtonGroup } from "@atlaskit/button";
import { AbortWargameButton } from "../AbortWargameButton";
var ActiveWargameComponent = function (props) {
    props.activeWargames.forEach(function (wargame) {
        props.wargameDashboardData
            .refetch({ id: wargame.id, skip: false })
            .then(function (response) {
            if (response !== undefined && response.data !== undefined) {
                var parsedData = response.data;
                if (parsedData !== undefined) {
                    wargame.signalFxDashboard = parsedData.warGameDashboard;
                }
            }
        });
    });
    return props.isLoading ? (React.createElement(Spinner, null)) : (React.createElement("div", null, props.activeWargames.length === 0 ? (React.createElement("div", null,
        React.createElement(Separator, null),
        React.createElement(Card, null,
            React.createElement("p", null, "No Wargames running now")))) : (props.activeWargames.map(function (activeWargame) {
        var _a, _b, _c, _d;
        var steps = [];
        var index = 1;
        (_a = activeWargame.taskGroupExecutions) === null || _a === void 0 ? void 0 : _a.forEach(function (taskGroupExecution) {
            var _a, _b;
            (_a = taskGroupExecution.steadyStateExecutions) === null || _a === void 0 ? void 0 : _a.forEach(function (steadyStateExecution, index2) {
                var probeMetric = "";
                Object.entries(steadyStateExecution.parameters
                    ? steadyStateExecution.parameters
                    : new Map()).forEach(function (entry) {
                    var _a = __read(entry, 2), key = _a[0], value = _a[1];
                    if (key === "probe_metric") {
                        probeMetric = value;
                    }
                });
                steps.push({
                    title: "steadystate " + probeMetric,
                    id: index,
                    status: steadyStateExecution.status
                });
                index++;
            });
            (_b = taskGroupExecution.faultExecutions) === null || _b === void 0 ? void 0 : _b.forEach(function (faultExecution, index2) {
                var _a;
                steps.push({
                    title: "Fault: " + ((_a = faultExecution.parameters) === null || _a === void 0 ? void 0 : _a.fault),
                    id: index,
                    status: faultExecution.status
                });
                index++;
            });
        });
        return (React.createElement("div", null,
            React.createElement(Separator, null),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { medium: 12 },
                    React.createElement(ButtonGroup, null,
                        React.createElement(Link, { to: "/services/" + encodeURIComponent(props.serviceId) + "/resilience/ondemand/wargame-details?id=" + activeWargame.id },
                            React.createElement(Button, { appearance: "subtle-link" },
                                "Experiment #",
                                activeWargame.id)),
                        React.createElement("a", { href: (_b = activeWargame === null || activeWargame === void 0 ? void 0 : activeWargame.signalFxDashboard) !== null && _b !== void 0 ? _b : "", target: "_blank", rel: "noopener noreferrer" },
                            React.createElement(Button, { iconBefore: React.createElement(ShortcutIcon, { label: "insight" }), appearance: "primary", isDisabled: !((_c = activeWargame.taskGroupExecutions) === null || _c === void 0 ? void 0 : _c.length) }, "Wargame Dashboard")),
                        React.createElement(AbortWargameButton, { id: activeWargame.id })))),
            React.createElement(Separator, null),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { medium: 8 },
                    React.createElement("p", null,
                        "Trigger: ",
                        activeWargame.trigger),
                    React.createElement("p", null,
                        "User:",
                        " ",
                        React.createElement("a", { href: "https://directory.prod.atl-paas.net/employees/" + activeWargame.userId, target: "_blank", rel: "noopener noreferrer" }, activeWargame.userId)),
                    React.createElement("p", null,
                        "Status: ",
                        statusLozenge(activeWargame.status))),
                React.createElement(GridColumn, { medium: 4 }, (_d = activeWargame.premiseExecutions) === null || _d === void 0 ? void 0 : _d.map(function (premiseExecution) { return (React.createElement(RightDiv, null,
                    "Premise setup: ",
                    statusLozenge(premiseExecution.status))); }))),
            React.createElement(Separator, null),
            React.createElement(Table, { cells: steps.map(function (wargameStep) { return [
                    wargameStep.id.toString(),
                    wargameStep.title,
                    statusLozenge(wargameStep.status)
                ]; }) })));
    }))));
};
export var ActiveWargame = compose(graphql(WargameDashboardQuery, {
    name: "wargameDashboardData",
    options: function (props) { return ({
        query: WargameDetailsQuery,
        variables: { id: props.wargameId, skip: true }
    }); }
}))(ActiveWargameComponent);
